import { formatSignedUnits } from '../../shared/format.ts';
import type { ChronologicalPnlPoint } from '../../analytics/profit-view.ts';

export function EquityChart(props: { points: readonly ChronologicalPnlPoint[] }) {
  if (props.points.length === 0) {
    return null;
  }
  const values = props.points.map((point) => point.cumulativePnl);
  const min = Math.min(0, ...values);
  const max = Math.max(0, ...values);
  const span = max - min || 1;
  const left = 8;
  const top = 8;
  const width = 640;
  const height = 160;
  const plotW = width - 16;
  const plotH = height - 16;
  const coords = props.points.map((point, index) => {
    const x = left + (index / Math.max(props.points.length - 1, 1)) * plotW;
    const y = top + plotH - ((point.cumulativePnl - min) / span) * plotH;
    return `${x},${y}`;
  });
  const zeroY = top + plotH - ((0 - min) / span) * plotH;
  const last = props.points[props.points.length - 1];

  return (
    <div>
      <svg role="img" aria-label="Historical cumulative strategy P and L" viewBox={`0 0 ${width} ${height + 12}`} className="w-full">
        <title>Historical cumulative strategy P&L</title>
        <line x1={left} y1={zeroY} x2={left + plotW} y2={zeroY} stroke="currentColor" strokeOpacity="0.2" />
        <polyline fill="none" stroke="#3f5d56" strokeWidth="1.5" points={coords.join(' ')} />
      </svg>
      <p className="text-xs text-muted">
        Chronological cumulative P&L across wagered rounds. Last value: {formatSignedUnits(last?.cumulativePnl ?? null)}.
      </p>
    </div>
  );
}
